
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Toaster } from '@/components/ui/toaster';
import { initSentry } from './lib/sentry';

initSentry();

// App provides AuthProvider itself; wrapping again here nested two
// providers and two auth subscriptions.
createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <Toaster />
  </>
);
